import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomFieldTypeName } from "@air/api/types";
import { Label } from "@air/primitive-label";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { chipToCustomField } from "~/components/CustomFields/CustomFieldInput/utils";
import { Select } from "~/components/Select/Select";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
import { boardCollectionAttemptedSubmissionFormSelector, boardCollectionClipsInvalidFieldsSelector } from "~/store/boardCollection/selectors";
import { useContentCollectionCustomFieldOptions } from "../hooks/useContentCollectionCustomFieldOptions";
export const BoardCollectionCustomFieldsSelect = (param)=>{
    let { disabled = false, field, required = false, onSelectionChange, clips, size = "large" } = param;
    const { data: customFieldValues } = useContentCollectionCustomFieldOptions({
        customFieldId: field.id,
        customFieldTypeName: field.type.title
    });
    const invalidFields = useSelector((st)=>boardCollectionClipsInvalidFieldsSelector(st, clips.map((param)=>{
            let { id } = param;
            return id;
        })));
    const attemptedSubmission = useSelector(boardCollectionAttemptedSubmissionFormSelector);
    const fieldIsInvalid = invalidFields.find((f)=>f.customFieldId === field.id);
    const showInvalidState = fieldIsInvalid && attemptedSubmission;
    const selectedOptions = useMemo(()=>{
        if (field.value) {
            return [
                {
                    value: field.value.id,
                    label: field.value.value,
                    borderRadius: 4,
                    backgroundHexColor: field.value.color.backgroundHex,
                    fontHexColor: field.value.color.fontHex
                }
            ];
        }
        if (field.values) {
            return field.values.map((fieldValue)=>({
                    value: fieldValue.id,
                    label: fieldValue.value,
                    borderRadius: 4,
                    backgroundHexColor: fieldValue.color.backgroundHex,
                    fontHexColor: fieldValue.color.fontHex
                }));
        }
        return [];
    }, [
        field
    ]);
    const options = useMemo(()=>{
        if (!!customFieldValues) {
            return customFieldValues.data.map((fieldValue)=>({
                    value: fieldValue.id,
                    label: fieldValue.value,
                    borderRadius: 4,
                    backgroundHexColor: fieldValue.color.backgroundHex,
                    fontHexColor: fieldValue.color.fontHex
                }));
        } else {
            return [];
        }
    }, [
        customFieldValues
    ]);
    const _onSelectionChange = useCallback(async (param)=>{
        let { chips } = param;
        if (customFieldValues === null || customFieldValues === void 0 ? void 0 : customFieldValues.data) {
            if (field.type.title === CustomFieldTypeName.singleSelect) {
                const value = chips[0] ? chipToCustomField(chips[0], customFieldValues.data) : null;
                onSelectionChange({
                    values: value ? [
                        value
                    ] : null
                });
            } else {
                onSelectionChange({
                    values: chips.length ? chips.reduce((curr, chip)=>{
                        const cfValue = customFieldValues.data.find((param)=>{
                            let { id } = param;
                            return chip.value === id;
                        });
                        if (cfValue) {
                            curr.push(cfValue);
                        }
                        return curr;
                    }, []) : null,
                    allValueIds: chips.map((param)=>{
                        let { value } = param;
                        return value;
                    })
                });
            }
        }
    }, [
        customFieldValues === null || customFieldValues === void 0 ? void 0 : customFieldValues.data,
        field.type.title,
        onSelectionChange
    ]);
    const Icon = customFieldIconMap[field.type.title];
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full flex-col gap-1",
        children: [
            /*#__PURE__*/ _jsxs(Label, {
                className: "flex items-center font-semibold",
                htmlFor: field.id,
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        className: "mr-1 size-4 text-pigeon-400"
                    }),
                    field.name,
                    required ? "*" : ""
                ]
            }),
            /*#__PURE__*/ _jsx(Select, {
                closeMenuOnSelect: field.type.title === CustomFieldTypeName.singleSelect,
                options: options,
                placeholder: "None",
                selectedOptions: selectedOptions,
                isSearchable: true,
                className: "w-full",
                maxDropdownHeight: 300,
                onSelectionChange: _onSelectionChange,
                isSingleSelect: field.type.title === CustomFieldTypeName.singleSelect,
                isClearable: true,
                size: size,
                renderAsInput: true,
                hasError: showInvalidState,
                disabled: disabled,
                isSticky: true
            })
        ]
    });
};
